import React, { useEffect, createElement } from 'react';
// Import the meta-pixel package with named imports instead of default import
import * as metaPixel from 'meta-pixel';
// Add performance monitoring
const reportWebVitals = metric => {
  // Analytics or logging code can go here
  console.log(metric);
};
export const MetaPixel = () => {
  useEffect(() => {
    try {
      // Initialize Facebook Pixel with your Pixel ID
      metaPixel.init('1227156125769606', {
        autoConfig: true,
        debug: false
      });
      // Track page view on initial load
      metaPixel.pageView();
      console.log('Meta Pixel initialized successfully');
      // Preconnect to external domains
      if (typeof document !== 'undefined') {
        const linkPreconnect = document.createElement('link');
        linkPreconnect.rel = 'preconnect';
        linkPreconnect.href = 'https://uploadthingy.s3.us-west-1.amazonaws.com';
        document.head.appendChild(linkPreconnect);
      }
    } catch (error) {
      console.error('Error initializing Meta Pixel:', error);
    }
  }, []);
  return null;
};
export const trackAddToCart = () => {
  try {
    metaPixel.track('AddToCart', {
      content_type: 'product',
      content_name: 'ClearNail Fungus Treatment',
      currency: 'USD',
      value: 49.99
    });
  } catch (error) {
    console.error('Error tracking AddToCart:', error);
  }
};
export const trackInitiateCheckout = () => {
  try {
    metaPixel.track('InitiateCheckout', {
      content_type: 'product',
      content_name: 'ClearNail Fungus Treatment',
      currency: 'USD',
      value: 49.99
    });
  } catch (error) {
    console.error('Error tracking InitiateCheckout:', error);
  }
};